import { ProfileModel } from "@/models/ProfileModel";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";

const API_URL =
    process.env["NODE_ENV"] === "production"
        ? "/api/profile"
        : //"https://crystaldsouza.northeurope.cloudapp.azure.com/api/profile";
          "http://localhost:3001/api/profile";

export const getProfile = async (): Promise<ProfileModel> => {
    if (!localStorage.getItem("userId")) {
        localStorage.setItem("userId", uuidv4());
    }
    const userId = localStorage.getItem("userId");
    const response = await axios.get(`${API_URL}/${userId}`);
    return (response.data || { UserID: userId }) as ProfileModel;
};

export const updateProfile = async (profile: ProfileModel) => {
    const response = await axios.post(`${API_URL}/`, profile);
    return response.data;
};
